export const EMAIL_UPDATE = 'EMAIL_UPDATE';